import React, { useContext, useEffect } from 'react';
import { AuthContext } from 'src/contexts';
import { useHttp } from 'src/hooks';

interface Props {
  setIsStepValid: (isValid: boolean) => void;
}

const AccountSetupInformation: React.FC<Props> = ({ setIsStepValid }) => {
  const { sendRequest } = useHttp();
  const { accessToken, profile } = useContext(AuthContext);

  const handleFacebookConnect = () => {
    sendRequest(
      {
        url: `facebook/login`,
        accessToken,
      },
      (data: string | any) => {
        if (data) {
          window.location.href = data;
        }
      },
    );
  };
  useEffect(() => {
    setIsStepValid(!!profile?.facebook);
  }, [profile?.facebook, setIsStepValid]);
  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl">
      <div className="max-w-2xl mx-auto space-y-10">
        <h2 className="text-[28px] text-center font-semibold font-inter text-black mb-10">
          Connect Your Facebook Account
        </h2>

        <div className="py-56 flex justify-center items-center">
          {profile?.facebook ? (
            <div className="text-center">
              <h1 className="text-xl font-semibold mb-4">Connected as</h1>
              <div className="flex items-center justify-center space-x-4">
                <img
                  src={profile.facebook.profilePicture}
                  alt={profile.facebook.name}
                  className="w-14 h-14 rounded-full border border-gray-300"
                />
                <span className="text-lg font-medium text-gray-900">{profile.facebook.name}</span>
              </div>
            </div>
          ) : (
            <button
              type="button"
              onClick={handleFacebookConnect}
              className="w-full py-3 rounded-full text-white bg-blue-600 hover:bg-blue-700 focus:outline-none transition-all duration-300 transform hover:scale-105"
            >
              Login with Facebook
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountSetupInformation;

{
  /* <form className="space-y-10"> */
}
{
  /* Facebook Page Login */
}
{
  /* <div>
            <h3 className="text-lg font-semibold text-black mb-6">Facebook page login</h3>
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="facebook-email"
                  className="block text-[#4A4D4F] text-base font-normal font-inter mb-2"
                >
                  Email or phone number
                </label>
                <input
                  type="email"
                  id="facebook-email"
                  placeholder="Enter email address or phone number"
                  className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                />
              </div>
              <div>
                <label
                  htmlFor="facebook-password"
                  className="block text-[#4A4D4F] text-base font-normal font-inter mb-2"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="facebook-password"
                  placeholder="Enter password"
                  className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                />
              </div>
            </div>
          </div> */
}

{
  /* Instagram Login */
}
{
  /* <div>
            <h3 className="text-lg font-semibold text-black mb-6">Instagram login</h3>
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="instagram-email"
                  className="block text-[#4A4D4F] text-base font-normal font-inter mb-2"
                >
                  Email or phone number
                </label>
                <input
                  type="email"
                  id="instagram-email"
                  placeholder="Enter email address or phone number"
                  className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                />
              </div>
              <div>
                <label
                  htmlFor="instagram-password"
                  className="block text-[#4A4D4F] text-base font-normal font-inter mb-2"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="instagram-password"
                  placeholder="Enter password"
                  className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                />
              </div>
            </div>
          </div> */
}

{
  /* Connect with Facebook Button */
}
{
  /* <div className="mt-6">
            <button
              type="button"
              onClick={handleFacebookConnect}
              className="w-full py-3 rounded-full text-white bg-blue-600 hover:bg-blue-700 focus:outline-none transition-all duration-300 transform hover:scale-105"
            >
              Connect with Facebook
            </button>
          </div>
          <div className="mt-6">
            <button
              type="button"
              onClick={handleInstagramConnect}
              className="w-full py-3 rounded-full text-white bg-blue-600 hover:bg-blue-700 focus:outline-none transition-all duration-300 transform hover:scale-105"
            >
              Connect with Instagram
            </button>
          </div> */
}
{
  /* </form> */
}
